<template>
  <div>
  <el-dialog title="代理老板" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="昵称" :label-width="formLabelWidth">
        <el-input v-model="form.nickName" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="手机号" :label-width="formLabelWidth">
        <el-input v-model="form.mobile" disabled=""></el-input>
      </el-form-item>
     
      
      <el-form-item label="是否加入2+1代理老板体系" v-if="!form.agentBoss" :label-width="formLabelWidth">
        <el-radio-group v-model="is_join">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
        <div class="gray9">选择是，普通用户直接加入2+1代理老板体系，加入后不可取消</div>
      </el-form-item>

      <el-form-item label="是否是老板" :label-width="formLabelWidth">
        <el-radio-group v-model="agent.is_boss">
          <el-radio v-if="!is_boss" :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
        <div class="gray9">提示: 设置为老板后将不能取消，请谨慎操作</div>
      </el-form-item>
      <el-form-item label="归属老板ID" :label-width="formLabelWidth">
        <el-input type="text" v-model="agent.boss_id" autocomplete="off">
        <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openUserDialog">选择归属老板</el-button>
        </el-input>
      </el-form-item>
  </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
   <!--用户选择-->
  <GetAgentBoss :is_open="open_user" @close="closeUserDialog"></GetAgentBoss>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  import GetAgentBoss from '@/components/user/GetAgentBoss.vue';
  export default {
    components: {
      GetAgentBoss
    },
    data() {
      return {
        is_join:0,
        open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        is_boss:0,
        agent:{
          user_id:0,
          is_boss:0,
          boss_id:0,
        }
      };
    },
    props: ['open_agentboss', 'form'],
    created() {
      this.dialogVisible = this.open_agentboss;
      if(this.form.agentBoss){
        this.agent = this.form.agentBoss;
        this.is_boss = this.form.agentBoss.is_boss;
      }else{
        this.agent.user_id = this.form.user_id
      }
    },
    methods: {
      /*修改用户*/
      editUser() {
        let self = this;
        self.loading = true;
        let params = self.agent;
        params.is_join = self.is_join;
        UserApi.editAgent(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，用户修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },
    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params[0];
        this.agent.boss_id = e.params[0].user_id;
      }
      this.open_user = false;
    },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Agentboss.vue